import { useState, useEffect } from 'react';

declare global {
  interface Window {
    WebApp?: {
      initData: string;
      initDataUnsafe: any;
      platform: string;
      version: string;
    };
  }
}

function getInitDataFromURL(): string | null {
  const hash = window.location.hash;
  if (!hash) return null;

  try {
    const params = new URLSearchParams(hash.substring(1));
    
    // Проверяем разные возможные имена параметра
    const webAppData = params.get('WebAppData') || 
                       params.get('initData') || 
                       params.get('tgWebAppData');
    
    if (webAppData) {
      console.log('📦 initData получен из URL-фрагмента (WebAppData)');
      return webAppData;
    }

    // Если параметр не найден, но есть другие параметры — собираем всё
    const allParams: string[] = [];
    for (const [key, value] of params.entries()) {
      // Игнорируем технические параметры
      if (key === 'WebAppPlatform' || key === 'WebAppVersion' || key === 'WebAppDeviceName') continue;
      allParams.push(`${key}=${value}`);
    }
    
    if (allParams.length > 0) {
      console.log('📦 initData собран из URL-фрагмента по частям');
      return allParams.join('&');
    }
  } catch (error) {
    console.warn('⚠️ Ошибка парсинга URL-фрагмента:', error);
  }
  
  return null;
}

export function useInitData() {
  const [initData, setInitData] = useState<string | null>(null);
  const [platform, setPlatform] = useState<string | null>(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    console.log('🔍 Проверка инициализации MAX WebApp...');
    console.log('🔍 window.WebApp:', window.WebApp);
    console.log('🔍 window.location.hash:', window.location.hash);

    // 1. Пытаемся получить initData из WebApp
    let data = window.WebApp?.initData || null;
    let source = 'WebApp';

    // 2. Если нет — пробуем из URL-фрагмента
    if (!data) {
      data = getInitDataFromURL();
      source = 'URL-fragment';
    }

    // 3. Если всё ещё нет — используем мок-данные ТОЛЬКО для разработки
    if (!data && process.env.NODE_ENV === 'development') {
      import('../utils/mockInitData')
        .then(({ getMockInitData }) => {
          const mockData = getMockInitData();
          setInitData(mockData);
          setPlatform('web');
          setIsReady(true);
          console.log('🧪 Используем мок-данные для разработки');
        })
        .catch(() => {
          setIsReady(true);
        });
      return;
    }

    if (data) {
      console.log(`✅ initData получен из ${source}`);
      console.log(`📝 Первые 100 символов: ${data.substring(0, 100)}...`);
      setInitData(data);
      setPlatform(window.WebApp?.platform || 'web');
    } else {
      console.warn('⚠️ initData не найден');
    }

    setIsReady(true);
  }, []);

  return { initData, platform, isReady };
}